import React, { Fragment, useState, useEffect } from 'react';

function CertificadoParteDosB({ onButtonClick, guardarDatosSegundo, rango, unidad, segundo }) {

    // Sincronizar estado cuando cambien las props de segundo
    useEffect(() => {
        if (segundo && (segundo.llegadaFinal || segundo.comparacionFinal || segundo.entregaFinal)) {
            let llegada = segundo.llegadaFinal && Array.isArray(segundo.llegadaFinal) && segundo.llegadaFinal.length > 0 
                ? segundo.llegadaFinal.map(d => ({...d, numeroStr: d.numero !== 0 ? String(d.numero) : ''}))
                : [{
                    name: '0',
                    numero: 0,
                    numeroStr: '',
                    usado: false
                }];
            
            let comparacion = segundo.comparacionFinal && Array.isArray(segundo.comparacionFinal) && segundo.comparacionFinal.length > 0 
                ? segundo.comparacionFinal.map(d => ({...d, numeroStr: d.numero !== 0 ? String(d.numero) : ''}))
                : [{
                    name: '0',
                    numero: 0,
                    numeroStr: '',
                    usado: false
                }];
            
            let entrega = segundo.entregaFinal && Array.isArray(segundo.entregaFinal) && segundo.entregaFinal.length > 0 
                ? segundo.entregaFinal.map(d => ({...d, numeroStr: d.numero !== 0 ? String(d.numero) : ''}))
                : [{
                    name: '0',
                    numero: 0,
                    numeroStr: '',
                    usado: false
                }];

            guardarTabla({
                llegada,
                comparcion: comparacion,
                entrega
            });
        }
    }, [segundo]);

    if ( segundo.llegadaFinal ) {
        if( segundo?.llegadaFinal[segundo?.llegadaFinal?.length-1].usado !== false ) {
            segundo.llegadaFinal.push({
                name: (parseInt(segundo.llegadaFinal[segundo.llegadaFinal.length - 1].name) + 1).toString(),
                numero: 0,
                numeroStr: '',
                usado:false
            });
        }
    }

    if ( segundo.comparacionFinal ) {
        if( segundo?.comparacionFinal[segundo?.comparacionFinal?.length-1].usado !== false ){
            segundo.comparacionFinal.push({
                name: (parseInt(segundo.comparacionFinal[segundo.comparacionFinal.length - 1].name) + 1).toString(),
                numero: 0,
                numeroStr: '',
                usado:false
            });
        }
    }

    if ( segundo.entregaFinal ) {
        if( segundo?.entregaFinal[segundo?.entregaFinal?.length-1].usado !== false ) {
            segundo.entregaFinal.push({
                name: (parseInt(segundo.entregaFinal[segundo.entregaFinal.length - 1].name) + 1).toString(),
                numero: 0,
                numeroStr: '',
                usado:false
            });
        }
    }

    const [ tabla, guardarTabla ] = useState({
        llegada: segundo.llegadaFinal ? segundo.llegadaFinal.map(d => ({...d, numeroStr: d.numero !== 0 ? String(d.numero) : ''})) : [{
            name: '0',
            numero: 0,
            numeroStr: '',
            usado: false
        }],
        comparcion: segundo.comparacionFinal ? segundo.comparacionFinal.map(d => ({...d, numeroStr: d.numero !== 0 ? String(d.numero) : ''})) : [{
            name: '0',
            numero: 0,
            numeroStr: '',
            usado: false
        }],
        entrega: segundo.entregaFinal ? segundo.entregaFinal.map(d => ({...d, numeroStr: d.numero !== 0 ? String(d.numero) : ''})) : [{
            name: '0',
            numero: 0,
            numeroStr: '',
            usado: false
        }],
    });    

    const actualizarInstrumentoI = (e) => {

        const existe = tabla.llegada.find(dato => dato.name === e.target.name);

        if ( existe ) {

            const actualizar = tabla.llegada;
            const valorStr = e.target.value.split(',').join('.');
            
            // Mantener el valor como string para permitir escribir puntos
            actualizar[existe.name].numeroStr = valorStr;
            
            // Solo parsear cuando el valor es válido (no termine en punto solitario)
            const valorNum = valorStr && !valorStr.endsWith('.') ? parseFloat(valorStr) : (valorStr ? actualizar[existe.name].numero : 0);
            
            if (isNaN(valorNum) || !valorNum) {
                actualizar[existe.name].numero = 0;
                actualizar[existe.name].usado = false;
            } else {
                actualizar[existe.name].numero = valorNum;
                actualizar[existe.name].usado = true;
            }

            const nuevo = actualizar.find( data => data.name === (parseInt(e.target.name) + 1).toString());
        
            if ( !nuevo && actualizar.length < 7 ) {

                actualizar.push({
                    name: `${parseInt(e.target.name) + 1}`,
                    numero: 0,
                    numeroStr: '',
                    usado: false
                });

            }

            guardarTabla({
                ...tabla,
                llegada: actualizar
            });

        }
    }

    const actualizarComparacion = (e) => {

        try {
            const existe = tabla.comparcion.find(dato => dato.name === e.target.name);

            if ( existe ) {

                const actualizar = tabla.comparcion;
                const valorStr = e.target.value.split(",").join(".");
                
                // Mantener el valor como string para permitir escribir puntos
                actualizar[existe.name].numeroStr = valorStr;
                
                // Solo parsear cuando el valor es válido (no termine en punto solitario)
                const valorNum = valorStr && !valorStr.endsWith('.') ? parseFloat(valorStr) : (valorStr ? actualizar[existe.name].numero : 0);

                if (isNaN(valorNum) || !valorNum) {
                    actualizar[existe.name].numero = 0;
                    actualizar[existe.name].usado = false;
                } else {
                    actualizar[existe.name].numero = valorNum;
                    actualizar[existe.name].usado = true;
                }

                const nuevo = actualizar.find( data => data.name === (parseInt(e.target.name) + 1).toString());
            
                if ( !nuevo && actualizar.length < 7 ) {

                    actualizar.push({
                        name: `${parseInt(e.target.name) + 1}`,
                        numero: 0,
                        numeroStr: '',
                        usado: false
                    });

                }

                guardarTabla({
                    ...tabla,
                    comparcion: actualizar
                });

            }
        } catch (error) {
            console.error(error);
        }
        
    }

    const actualizarEntrega = (e) => {
        
        try {
            const existe = tabla.entrega.find(dato => dato.name === e.target.name);

            if ( existe ) {

                const actualizar = tabla.entrega;
                const valorStr = e.target.value.split(",").join(".");
                
                // Mantener el valor como string para permitir escribir puntos
                actualizar[existe.name].numeroStr = valorStr;
                
                // Solo parsear cuando el valor es válido (no termine en punto solitario)
                const valorNum = valorStr && !valorStr.endsWith('.') ? parseFloat(valorStr) : (valorStr ? actualizar[existe.name].numero : 0);

                if (isNaN(valorNum) || !valorNum) {
                    actualizar[existe.name].numero = 0;
                    actualizar[existe.name].usado = false;
                } else {
                    actualizar[existe.name].numero = valorNum;
                    actualizar[existe.name].usado = true;
                }

                const nuevo = actualizar.find( data => data.name === (parseInt(e.target.name) + 1).toString());
            
                if ( !nuevo && actualizar.length < 7 ) {

                    actualizar.push({
                        name: `${parseInt(e.target.name) + 1}`,
                        numero: 0,
                        numeroStr: '',
                        usado: false
                    });

                }

                guardarTabla({
                    ...tabla,
                    entrega: actualizar
                });

            }
        } catch (error) {
            console.error(error);
        }
    }

    const desviacionCalculo = (index, estado) => {
        
        if ( estado ) {

            return (tabla.entrega[index].numero - tabla.comparcion[index].numero).toFixed(1);                

        }

        return (tabla.llegada[index].numero - tabla.comparcion[index].numero).toFixed(1);
    }

    const porcentajeDesviacion = (index, estado) => {

        const res = ((desviacionCalculo(index, estado) * 100) / tabla.comparcion[index].numero).toFixed(1);

        return isNaN(res) ? null : res;

    }

    const validarForm = () => {

        const { llegada, comparcion, entrega } = tabla;
        
        if( !( llegada.length === comparcion.length === entrega.length ) && ( llegada.length > 0 || comparcion.length > 0 || entrega.length > 0 ) ){
            return false;
        }

        return true;

    }

    const enviar = (e) => {

        e.preventDefault();
        
        const llegadaFinal = tabla.llegada.filter(dato => dato.usado === true);
        const comparacionFinal = tabla.comparcion.filter(dato => dato.usado === true);
        const entregaFinal = tabla.entrega.filter(dato => dato.usado === true);

        guardarDatosSegundo({
            llegadaFinal,
            comparacionFinal,
            entregaFinal
        });

        onButtonClick("pagethree");
    }

    const regresar = () => {
        onButtonClick("pageone")
    }

    const avanzar = (event) => {
        if (event.keyCode === 13 && event.target.nodeName === "INPUT" && event.target.type !== 'submit') {
            var form = event.target.form;
            var index = Array.prototype.indexOf.call(form, event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    }

    useEffect(() => {

    }, [tabla.comparcion, tabla.entrega, tabla.llegada]);

    return (
        <Fragment>

            <form onSubmit={enviar} className='certificado__form-mw' onKeyDown={avanzar}>
                
                <h3 className="card-body-subtitle">No importa si deja casillas en blanco</h3>

                <div className='certificado__componente certificado__componente__rango certificado-wd mt-1'>
                    <div className='pdf__titulo-dueño certificado__subtitulo certificado__titulo'>
                        <h2>Condiciones De Recepción Del Instrumento:</h2>
                    </div>
                    <table className="table table-hover certificado__table">
                        <thead>
                            <tr className='table__head'>
                                <th scope="col">Rango</th>
                                <th scope="col">Lectura Patrón</th>
                                <th scope="col">Lectura Instrumento</th>
                                <th scope="col">Desviación</th>
                                <th scope="col">% Desviación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='table__tr'>
                                <td className='certificado__inp'>{rango} {unidad}</td>

                                <td>
                                    <p className='pdf__tabla__titulo' >Ascendente</p>
                                    <div>
                                        {
                                            tabla.llegada.length > 0 ? 

                                                tabla.llegada.map((dato, index) => (
                                                    <div key={index} >
                                                        <input 
                                                            type="text"
                                                            name={index}
                                                            className={'certificado__inp'}
                                                            onChange={actualizarInstrumentoI}
                                                            value={dato.numeroStr || ''}
                                                        />
                                                    </div>
                                                ))
                                            :
                                                null
                                        }
                                    </div>
                                    {/* <p className='pdf__tabla__certificado' >SCJR 8700-02</p> */}
                                </td>

                                <td>
                                    <p className='pdf__tabla__titulo' >Ascendente</p>
                                    <div>
                                        {
                                            tabla.comparcion.length > 0 ? 

                                                tabla.comparcion.map((dato, index) => (
                                                    <div key={index} >
                                                        <input 
                                                            type="text"
                                                            name={index}
                                                            className={'certificado__inp'}
                                                            onChange={actualizarComparacion}
                                                            value={dato.numeroStr || ''}
                                                        />
                                                    </div>
                                                ))
                                            :
                                                null
                                        }
                                    </div>
                                </td>

                                <td>
                                    <p className='certificado__invisible' >aaa</p>
                                    <div>
                                        {
                                            tabla.comparcion.length === tabla.llegada.length ? 

                                                tabla.comparcion.map((dato, index) => (
                                                    <div key={index} >
                                                        <input 
                                                            type="text"
                                                            name={index}
                                                            disabled={true}
                                                            className={'certificado__inp'}
                                                            // onChange={actualizarComparacion}
                                                            value={desviacionCalculo(index, false)}
                                                        />
                                                    </div>
                                                ))
                                            :
                                                null
                                        }
                                    </div>
                                </td>

                                <td>
                                    <p className='certificado__invisible' >aaa</p>
                                    <div>
                                        {
                                            tabla.comparcion.length === tabla.llegada.length ? 

                                                tabla.comparcion.map((dato, index) => (
                                                    <div key={index} >
                                                        <input 
                                                            type="text"
                                                            name={index}
                                                            disabled={true}
                                                            className={'certificado__inp'}
                                                            // onChange={actualizarComparacion}
                                                            value={porcentajeDesviacion(index, false)}
                                                        />
                                                    </div>
                                                ))
                                            :
                                                null
                                        }
                                    </div>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 className="card-body-subtitle">No importa si deja casillas en blanco</h3>

                <div className='certificado__componente certificado__componente__rango certificado-wd mt-1'>
                    <div className='pdf__titulo-dueño certificado__subtitulo certificado__titulo'>
                        <h2>Condiciones De Entrega Del Instrumento:</h2>
                    </div>
                    <table className="table table-hover certificado__table">
                        <thead>
                            <tr className='table__head'>
                                <th scope="col">Rango</th>
                                <th scope="col">Lectura Patrón</th>
                                <th scope="col">Lectura Instrumento</th>
                                <th scope="col">Desviación</th>
                                <th scope="col">% Desviación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='table__tr'>
                                <td className='certificado__inp'>{rango} {unidad}</td>

                                <td>
                                    <p className='pdf__tabla__titulo' >Ascendente</p>
                                    <div>
                                        {
                                            tabla.entrega.length > 0 ? 

                                                tabla.entrega.map((dato, index) => (
                                                    <div key={index} >
                                                        <input 
                                                            type="text"
                                                            name={index}
                                                            className={'certificado__inp'}
                                                            onChange={actualizarEntrega}
                                                            value={dato.numeroStr || ''}
                                                        />
                                                    </div>
                                                ))
                                            :
                                                null
                                        }
                                    </div>
                                    {/* <p className='pdf__tabla__certificado' >SCJR 8700-02</p> */}
                                </td>

                                <td>
                                    <p className='pdf__tabla__titulo' >Ascendente</p>
                                    <div>
                                        {
                                            tabla.comparcion.length > 0 ? 

                                                tabla.comparcion.map((dato, index) => (
                                                    <div key={index} >
                                                        <input 
                                                            type="text"
                                                            name={index}
                                                            className={'certificado__inp'}
                                                            onChange={actualizarComparacion}
                                                            value={dato.numeroStr || ''}
                                                        />
                                                    </div>
                                                ))
                                            :
                                                null
                                        }
                                    </div>
                                </td>

                                <td>
                                    <p className='certificado__invisible' >aaa</p>
                                    <div>
                                        {
                                            tabla.comparcion.length === tabla.entrega.length ? 

                                                tabla.comparcion.map((dato, index) => (
                                                    <div key={index} >
                                                        <input 
                                                            type="text"
                                                            name={index}
                                                            disabled={true}
                                                            className={'certificado__inp'}
                                                            value={desviacionCalculo(index, true)}
                                                        />
                                                    </div>
                                                ))
                                            :
                                                null
                                        }
                                    </div>
                                </td>

                                <td>
                                    <p className='certificado__invisible' >aaa</p>
                                    <div>
                                        {
                                            tabla.comparcion.length === tabla.entrega.length ? 

                                                tabla.comparcion.map((dato, index) => (
                                                    <div key={index} >
                                                        <input 
                                                            type="text"
                                                            name={index}
                                                            disabled={true}
                                                            className={'certificado__inp'}
                                                            value={porcentajeDesviacion(index, true)}
                                                        />
                                                    </div>
                                                ))
                                            :
                                                null
                                        }
                                    </div>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className='opciones' >
                    <div className='enviar' >
                        <div className='btn-new btn-return' onClick={regresar}>
                            Regresar
                        </div>
                    </div>

                    <div className="enviar">
                        <input 
                            type="submit" 
                            className={ validarForm() ? "btn-new"  : 'btn-new btn-success-new'}
                            value="Siguiente"
                            disabled={validarForm()}
                        />
                    </div>
                </div>
            </form>
        </Fragment>
    )
}

export default CertificadoParteDosB
